import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
export function ModelsDropdown({ models, currentPath, white = false }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <li className="relative">
      <span
        onClick={() => setOpen(!open)}
        className={`cursor-pointer nav-link transition duration-300 flex items-center gap-1 ${
          white ? "text-white" : ""
        } ${
          models.some((model) => model.to === location.pathname)
            ? "font-extrabold underline underline-offset-4 text-[#74BB43]"
            : "font-semibold opacity-80 hover:opacity-100"
        }

    }`}
      >
        Modèles
        <span className="transition-transform duration-300">
          <i className="fa-solid fa-caret-down"></i>
        </span>
      </span>

      {/* Sous-menu */}
      <ul
        className={`absolute left-0 top-full mt-2 bg-white border shadow-md z-20 min-w-[230px] ${
          open ? "block" : "hidden"
        }`}
      >
        {models.map((model) => (
          <li key={model.to}>
            <Link
              to={model.to}
              className={`block px-4 py-2 text-sm hover:bg-gray-100 border border-b mb-2 ${
                currentPath === model.to
                  ? "text-[#74BB43] font-extrabold"
                  : "font-semibold opacity-80 hover:opacity-100"
              }`}
            >
              {model.label}
            </Link>
          </li>
        ))}
      </ul>
    </li>
  );
}
